import React from "react";
import { Table, Tag, Typography } from "antd";

const { Text } = Typography;

const STATUS_META = {
    current: { color: "blue", label: "当前" },
    planned: { color: "default", label: "规划中" },
};

const PriceComparisonBreakdownTable = ({ rows }) => {
    return (
        <Table
            rowKey="key"
            size="small"
            pagination={false}
            dataSource={rows}
            columns={[
                {
                    title: "分项",
                    dataIndex: "label",
                    width: 220,
                    render: (_, row) => (
                        <div>
                            <Text strong>{row.label}</Text>
                            <br />
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                {row.description}
                            </Text>
                        </div>
                    ),
                },
                {
                    title: "我方参考快照",
                    dataIndex: "internalValue",
                    width: 220,
                },
                {
                    title: "供应商报价快照",
                    dataIndex: "supplierValue",
                    width: 220,
                },
                {
                    title: "解释",
                    dataIndex: "differenceHint",
                },
                {
                    title: "状态",
                    dataIndex: "status",
                    width: 90,
                    render: (status) => <Tag color={STATUS_META[status]?.color}>{STATUS_META[status]?.label}</Tag>,
                },
            ]}
        />
    );
};

export default PriceComparisonBreakdownTable;
